import { EventGraphBase, EventGraphNode, EventGraphNodeNotice, EventGraphNodeRender, EventHandlerCmdEnd, EventHandlerGrid, EventHandlerObjectInput, EventHandlerStart, NeedInputEnum, PythaEventName, UpdateType } from "pytha2";
import { EventHandlerDeletVerticalAxisLine } from "../event-handler/EHDeleteVerticalAxisLine";

/**
 * 删除竖向轴线图
 */
export class EventGraphDeleteVeritcalAxisLine extends EventGraphBase {

    /**
     * DeleteVeritcalAxisLine指令，删除竖向轴线
     */
    static cmd: string = "DELETEVERITCALAXISLINE"

    generate(): void {
        const node1 = new EventGraphNode(this, EventHandlerStart);
        const node2 = new EventGraphNodeRender(this, true, UpdateType.ALL);
        const node3 = new EventGraphNodeNotice(this, {
            cmd: 'need_input', data: [{
                type: NeedInputEnum.ACTIVE,
                description: "",
                option: 'PARAMS',
                inputTypes: [PythaEventName.OBJECT]
            }]
        });
        const node4 = new EventGraphNode(this, EventHandlerDeletVerticalAxisLine);
        const node5 = new EventGraphNode(this, EventHandlerGrid);
        const node6 = new EventGraphNode(this, EventHandlerCmdEnd);
        const node7 = new EventGraphNode(this, EventHandlerObjectInput);

        this.addEdge(node1, node3);
        this.addEdge(node4, node5);
        this.addEdge(node5, node2);
        this.addEdge(node2, node6);
        this.addEdge(node3, node7);
        this.addEdge(node7, node4);

        // 指定初始状态下的当前节点和头节点
        this.currentPointers = [node1];
        this.head = node1;

        // https://event.graph.tncet.com/graphs/139
    }
}